import React, { useState } from 'react'
import './AddStaff.css'
import { Radio } from 'antd'
import AddStaffTab from './AddStaffTab';
import MonthlyHistory from './MonthlyHistory';
function AddStaff() {
    const [size, setSize] = useState("add");
 
    const onChange = (e: RadioChangeEvent) => {
        setSize(e.target.value);
      };
    return (
        <>
        <div className='flex mt-2 [&_label]:!border-none [&_label]:px-4 [&_label]:!rounded-full [&_label]:bg-[#E4EEFC] [&_label]:!text-[#2D2D2D] [&_label]:min-w-[112px] text-center [&_label]:font-medium [&_.ant-radio-button-wrapper-checked]:!bg-[#1F4972] [&_.ant-radio-button-wrapper-checked]:!text-[white]'>
            <Radio.Group value={size} onChange={onChange} className='flex gap-2'>
                <Radio.Button value="add"><span className='!text-sm !py-[6px] block !px-4'>Add Staff</span></Radio.Button>
                <Radio.Button value="monthly"><span className='!text-sm !py-[6px] block !px-5'>Monthly History</span></Radio.Button>
                {/* <Radio.Button value="user">User wise History</Radio.Button> */}
            </Radio.Group>
        </div>

        <div>
            {size === 'add' ? <AddStaffTab /> : size === 'monthly' ? <MonthlyHistory /> :''}
        </div>
        </>
    )
}

export default AddStaff